import { MessageBanner } from "@fluidattacks/design";
import { useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";

import { authContext } from "context/auth";
import { useDailyBanner } from "hooks/use-banner";
import { bannerStorage } from "storage/banner";
import { openUrl } from "utils/resource-helpers";

interface ITrialBannerProps {
  remainingDays: number;
}

const TrialBanner = ({ remainingDays }: ITrialBannerProps): JSX.Element => {
  const { t } = useTranslation();
  const { userEmail } = useContext(authContext);

  const handleButtonClick = useCallback((): void => {
    openUrl(
      "https://res.cloudinary.com/fluid-attacks/image/upload/fl_attachment:Fluid-Attacks-Plans/v1743522883/integrates/plans/Fluid_Attacks-Plans_and_pricing_2025.pdf",
    );
  }, []);

  const closedDate = bannerStorage.getItem(`closed-${userEmail}`) as
    | string
    | null;

  const useBanner = useDailyBanner("user-email", userEmail, closedDate);
  const handleCloseBanner = useCallback((): void => {
    void bannerStorage.setItem(`closed-${userEmail}`, new Date().toISOString());
  }, [userEmail]);

  return (
    <MessageBanner
      buttonText={t("dashboard.freeTrial.button")}
      message={t("dashboard.freeTrial.message", { remainingDays })}
      onClickButton={handleButtonClick}
      onClose={handleCloseBanner}
      show={useBanner}
    />
  );
};

export { TrialBanner };
